import { type AuthState, subscribeIam } from '@b2x/authentication';
import { storage } from '@b2x/std/core/storage.mjs';

import type { ImportMap, LoginData } from '@/types';

import { logger } from './logger';

const log = logger.createLogger('HELPERS');

export function buildLoginObject(authState: AuthState, country: string): LoginData {
  return {
    authState: {
      jwe: authState.jwe,
      email: authState.email || '',
    },
    currentPage: globalThis.location.href,
    country: country,
  };
}

export const getImportMap = (): ImportMap => {
  const script = document.querySelector('script[type="importmap"]');
  if (script?.textContent) {
    try {
      return JSON.parse(script.textContent);
    } catch {
      log.error('Error parsing import map');
    }
  }
  return {
    imports: {},
  };
};

export async function getAuthenticationState() {
  return await new Promise<AuthState>((resolve) => {
    subscribeIam((state) => {
      resolve(state);
    });
  });
}

export function dispatchLoginActionEvent(eventName: string, detail: Record<string, string>) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail,
  });

  document.dispatchEvent(event);
}

export function setLegacyStorageValues(authState: AuthState) {
  if (authState.isLoggedIn) {
    storage.session.set('ow_aem_loginstate', 'logged_in', false);
  } else {
    storage.session.set('ow_aem_loginstate', 'logged_out', false);
  }
}
